import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { FileText, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaOrientacaoPreviaCriada = (acao: string): boolean => {
    const texto = (acao || '').toLowerCase().trim();
    return (
        texto.includes('orientações prévias criadas') ||
        texto.includes('criou orientacao previa')
    );
};

const getIconOrientacaoPrevia = (_acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: FileText, color: 'var(--c10b981)' };
};

export default function CardOrientacaoPreviaCriada({
    item,
    onNavigateToFile,
    isExpanded,
    onToggleExpand
}: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconOrientacaoPrevia(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={<ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />}
        />
    );
}

export const orientacaoPreviaCriadaConfig = {
    tipo: 'orientacao_previa_criada',
    detectaTipo: detectaOrientacaoPreviaCriada,
    getIcon: getIconOrientacaoPrevia,
    temExpansao: () => true,
    Component: CardOrientacaoPreviaCriada
};

